import Route from '@ember/routing/route';

export default class AdminRoute extends Route {}
